// パスはここに一箇所にまとめる
export const files = {
  en: {
    destinationsActivities: {
      hotelRunningMap: "/en/assets/files/pdf/Hotel-Running-Map-2024.pdf",
    },
    dining: {
      yanone: {
        otherMenu: "/en/assets/files/pdf/yanone-sushi-other-menu.pdf",
        setMenu: "/en/assets/files/pdf/yanone-sushi-set-menu.pdf",
      },
    },
  },
  ko: {},
  "zh-cn": {},
  "zh-tw": {},
} as const;

export const videos = {
  en: {
    kv: "/en/assets/videos/kv.mp4",
    roomsSuites: "/en/assets/videos/rooms.mp4",
    dining: "/en/assets/videos/dining.mp4",
  },
  ko: {},
  "zh-cn": {},
  "zh-tw": {},
} as const;

// 1. "jpg","jpeg","png"は自動でwebpに変換され、CustomImageコンポーネントで追加されます
// 2. getMediaPath関数を使用してpathを取得している場合は、
// デフォルトはenの画像を表示し、以下のkoなど他の言語にpathを追加すれば自動でその画像が表示されます
// ※ 直接images.en.xxxのように指定している場合は自動では切り替わりません。
export const images = {
  en: {
    common: {
      noImage: "/en/assets/images/common/noimage.png",
      bgPattern01: "/en/assets/images/common/bg_pattern_01.png",
      bgPattern01Sp: "/en/assets/images/common/bg_pattern_01_sp.png",
      bgPattern01Sp2: "/en/assets/images/common/bg_pattern_01_sp2.png",
      bgPattern02: "/en/assets/images/common/bg_pattern_02.jpg",
      bgPattern02Sp: "/en/assets/images/common/bg_pattern_02_sp.jpg",
      bgPattern02Webp: "/en/assets/images/common/bg_pattern_02.webp",
      bgPattern02SpWebp: "/en/assets/images/common/bg_pattern_02_sp.webp",
      bgPattern03: "/en/assets/images/common/bg_pattern_03.jpg",
      logoLifestyle: "/en/assets/images/common/logo_lifestyle.svg",
      logoPrefer: "/en/assets/images/common/logo_prefer.svg",
      logoTripadvisor: "/en/assets/images/common/logo_tripadvisor.svg",
      logoTrustyou: "/en/assets/images/common/logo_trustyou.svg",
      paginationCircleCurrent:
        "/en/assets/images/common/pagination_circle_current.svg",
      paginationCircleNext:
        "/en/assets/images/common/pagination_circle_next.svg",
      paginationCirclePrev:
        "/en/assets/images/common/pagination_circle_prev.svg",
      tripAdviser:
        "/en/assets/images/common/Tripadvisor_Logo_dark-bg_circle-white_RGB.svg",
    },
    icons: {
      bag: "/en/assets/images/icons/ico_bag.svg",
      bell: "/en/assets/images/icons/ico_bell.svg",
      breakfast: "/en/assets/images/icons/ico_breakfast.svg",
      carry: "/en/assets/images/icons/ico_carry.svg",
      clockCheck: "/en/assets/images/icons/ico_clock_check.svg",
      coffee: "/en/assets/images/icons/ico_coffee.svg",
      enter: "/en/assets/images/icons/ico_enter.svg",
      nonSmoking: "/en/assets/images/icons/ico_non_smoking.svg",
      parking: "/en/assets/images/icons/ico_parking.svg",
      payment: "/en/assets/images/icons/ico_payment.svg",
      security: "/en/assets/images/icons/ico_security.svg",
      shirt: "/en/assets/images/icons/ico_shirt.svg",
      staff: "/en/assets/images/icons/ico_staff.svg",
      stroller: "/en/assets/images/icons/ico_stroller.svg",
      swimming: "/en/assets/images/icons/ico_swimming.svg",
      wheelchair: "/en/assets/images/icons/ico_wheelchair.svg",
      wifi: "/en/assets/images/icons/ico_wifi.svg",
      instagram: "/en/assets/images/icons/icon_instagram.svg",
      facebook: "/en/assets/images/icons/icon_facebook.svg",
      youtube: "/en/assets/images/icons/icon_youtube.svg",
      train: "/en/assets/images/icons/icon_train.svg",
      subway: "/en/assets/images/icons/icon_subway.svg",
      car: "/en/assets/images/icons/icon_car.svg",
      walk: "/en/assets/images/icons/icon_walk.svg",
    },
    pages: {
      home: {
        fv1: "/en/assets/images/pages/top/img_fv_01.jpg",
        fv2: "/en/assets/images/pages/top/img_fv_02.jpg",
        fv3: "/en/assets/images/pages/top/img_fv_03.jpg",
        fv4: "/en/assets/images/pages/top/img_fv_04.jpg",
        fvSp1: "/en/assets/images/pages/top/img_fv_sp_01.jpg",
        fvSp2: "/en/assets/images/pages/top/img_fv_sp_02.jpg",
        fvSp3: "/en/assets/images/pages/top/img_fv_sp_03.jpg",
        fvSp4: "/en/assets/images/pages/top/img_fv_sp_04.jpg",
        imgDining: "/en/assets/images/pages/top/img_dining.jpg",
        imgHall: "/en/assets/images/pages/top/img_hall.jpg",
        mapLarge: "/en/assets/images/pages/top/img_map_large.jpg",
        mapSmall: "/en/assets/images/pages/top/img_map_small.jpg",
        featureServicePorter: "/en/assets/images/pages/top/img_featureservice_porter.png",
      },
      roomsSuites: {
        top: {
          bgTitle:
            "/en/assets/images/pages/rooms-suites/bg-title/bg_rooms-suites.jpg",
          bgTitleSp:
            "/en/assets/images/pages/rooms-suites/bg-title/bg_rooms-suites_sp.jpg",
        },
        accessibleRoom: {
          bgTitle:
            "/en/assets/images/pages/rooms-suites/bg-title/bg_accessible-room.jpg",
          bgTitleSp:
            "/en/assets/images/pages/rooms-suites/bg-title/bg_accessible-room_sp.jpg",
          listImage:
            "/en/assets/images/pages/rooms-suites/img_list_accessible-room.jpg",
          image01:
            "/en/assets/images/pages/rooms-suites/img_accessible-room_01.jpg",
          image02:
            "/en/assets/images/pages/rooms-suites/img_accessible-room_02.jpg",
          image03:
            "/en/assets/images/pages/rooms-suites/img_accessible-room_03.jpg",
          image04:
            "/en/assets/images/pages/rooms-suites/img_accessible-room_04.jpg",
          image05:
            "/en/assets/images/pages/rooms-suites/img_accessible-room_05.jpg",
        },
        breakfast: {
          bgTitle: "/en/assets/images/pages/rooms-suites/bg-title/bg_breakfast.jpg",
          bgTitleSp: "/en/assets/images/pages/rooms-suites/bg-title/bg_breakfast_sp.jpg",
          listImage: "/en/assets/images/pages/rooms-suites/img_list_breakfast.jpg",
          image01: "/en/assets/images/pages/rooms-suites/img_breakfast_01.jpg",
          image02: "/en/assets/images/pages/rooms-suites/img_breakfast_02.jpg",
          image03: "/en/assets/images/pages/rooms-suites/img_breakfast_03.jpg",
          image04: "/en/assets/images/pages/rooms-suites/img_breakfast_04.jpg",
        },
        executiveDeluxe: {
          bgTitle:
            "/en/assets/images/pages/rooms-suites/bg-title/bg_executive-deluxe.jpg",
          bgTitleSp:
            "/en/assets/images/pages/rooms-suites/bg-title/bg_executive-deluxe_sp.jpg",
          listImage:
            "/en/assets/images/pages/rooms-suites/img_list_executive-deluxe.jpg",
          image01:
            "/en/assets/images/pages/rooms-suites/img_executive-deluxe_01.jpg",
          image02:
            "/en/assets/images/pages/rooms-suites/img_executive-deluxe_02.jpg",
          image03:
            "/en/assets/images/pages/rooms-suites/img_executive-deluxe_03.jpg",
          image04:
            "/en/assets/images/pages/rooms-suites/img_executive-deluxe_04.jpg",
          floorMap01:
            "/en/assets/images/pages/rooms-suites/floor-map/executiveFloorDeluxeRoomsDeluxeDouble.jpg",
          floorMap02:
            "/en/assets/images/pages/rooms-suites/floor-map/executiveFloorDeluxeRoomsDeluxeTwin.jpg"
        },
        executiveLounge: {
          bgTitle:
            "/en/assets/images/pages/rooms-suites/bg-title/bg_executive-lounge.jpg",
          bgTitleSp:
            "/en/assets/images/pages/rooms-suites/bg-title/bg_executive-lounge_sp.jpg",
          listImage:
            "/en/assets/images/pages/rooms-suites/img_list_executive-lounge.jpg",
          image01:
            "/en/assets/images/pages/rooms-suites/img_executive-lounge_01.jpg",
          image02:
            "/en/assets/images/pages/rooms-suites/img_executive-lounge_02.jpg",
          image03:
            "/en/assets/images/pages/rooms-suites/img_executive-lounge_03.jpg",
          image04:
            "/en/assets/images/pages/rooms-suites/img_executive-lounge_04.jpg",
          image05:
            "/en/assets/images/pages/rooms-suites/img_executive-lounge_05.jpg",
          image06:
            "/en/assets/images/pages/rooms-suites/img_executive-lounge_06.jpg",
          imageSm01:
            "/en/assets/images/pages/rooms-suites/img_executive-lounge_sm_01.jpg",
          imageSm02:
            "/en/assets/images/pages/rooms-suites/img_executive-lounge_sm_02.jpg",
          imageSm03:
            "/en/assets/images/pages/rooms-suites/img_executive-lounge_sm_03.jpg",
          imageSm04:
            "/en/assets/images/pages/rooms-suites/img_executive-lounge_sm_04.jpg",
          imageSm05:
            "/en/assets/images/pages/rooms-suites/img_executive-lounge_sm_05.jpg",
        },
        executiveStandard: {
          bgTitle:
            "/en/assets/images/pages/rooms-suites/bg-title/bg_executive-standard.jpg",
          bgTitleSp:
            "/en/assets/images/pages/rooms-suites/bg-title/bg_executive-standard_sp.jpg",
          listImage:
            "/en/assets/images/pages/rooms-suites/img_list_executive-standard.jpg",
          image01:
            "/en/assets/images/pages/rooms-suites/img_executive-standard_01.jpg",
          image02:
            "/en/assets/images/pages/rooms-suites/img_executive-standard_02.jpg",
          image03:
            "/en/assets/images/pages/rooms-suites/img_executive-standard_03.jpg",
          image04:
            "/en/assets/images/pages/rooms-suites/img_executive-standard_04.jpg",
          floorMap01:
            "/en/assets/images/pages/rooms-suites/floor-map/executiveFloorStandardRoomsDeluxeDouble.jpg",
          floorMap02:
            "/en/assets/images/pages/rooms-suites/floor-map/executiveFloorStandardRoomsExeStandardDouble.jpg",
          floorMap03:
            "/en/assets/images/pages/rooms-suites/floor-map/executiveFloorStandardRoomsExeStandardSingle.jpg"
        },
        gym: {
          bgTitle: "/en/assets/images/pages/rooms-suites/bg-title/bg_gym.jpg",
          bgTitleSp: "/en/assets/images/pages/rooms-suites/bg-title/bg_gym_sp.jpg",
          listImage: "/en/assets/images/pages/rooms-suites/img_list_gym.jpg",
          image01: "/en/assets/images/pages/rooms-suites/img_gym_01.jpg",
          image02: "/en/assets/images/pages/rooms-suites/img_gym_02.jpg",
          image03: "/en/assets/images/pages/rooms-suites/img_gym_03.jpg",
          image04: "/en/assets/images/pages/rooms-suites/img_gym_04.jpg",
          image05: "/en/assets/images/pages/rooms-suites/img_gym_05.jpg",
        },
        loccitane: {
          bgTitle: "/en/assets/images/pages/rooms-suites/bg-title/bg_loccitane.jpg",
          bgTitleSp: "/en/assets/images/pages/rooms-suites/bg-title/bg_loccitane_sp.jpg",
          image01: "/en/assets/images/pages/rooms-suites/img_loccitane_01.jpg",
          image02: "/en/assets/images/pages/rooms-suites/img_loccitane_02.jpg",
          image03: "/en/assets/images/pages/rooms-suites/img_loccitane_03.jpg",
          image04: "/en/assets/images/pages/rooms-suites/img_loccitane_04.jpg",
        },
        roomService: {
          bgTitle:
            "/en/assets/images/pages/rooms-suites/bg-title/bg_roomservice.jpg",
          bgTitleSp:
            "/en/assets/images/pages/rooms-suites/bg-title/bg_roomservice_sp.jpg",
          listImage:
            "/en/assets/images/pages/rooms-suites/img_list_room-service.jpg",
          image01:
            "/en/assets/images/pages/rooms-suites/img_room-service_01.jpg",
          image02:
            "/en/assets/images/pages/rooms-suites/img_room-service_02.jpg",
          image03:
            "/en/assets/images/pages/rooms-suites/img_room-service_03.jpg",
          image04:
            "/en/assets/images/pages/rooms-suites/img_room-service_04.jpg",
          image05:
            "/en/assets/images/pages/rooms-suites/img_room-service_05.jpg",
        },
        royalSuite: {
          bgTitle:
            "/en/assets/images/pages/rooms-suites/bg-title/bg_royal-suite.jpg",
          bgTitleSp:
            "/en/assets/images/pages/rooms-suites/bg-title/bg_royal-suite_sp.jpg",
          listImage:
            "/en/assets/images/pages/rooms-suites/img_list_royal-suite.jpg",
          image01:
            "/en/assets/images/pages/rooms-suites/img_royal-suite_01.jpg",
          image02:
            "/en/assets/images/pages/rooms-suites/img_royal-suite_02.jpg",
          image03:
            "/en/assets/images/pages/rooms-suites/img_royal-suite_03.jpg",
          image04:
            "/en/assets/images/pages/rooms-suites/img_royal-suite_04.jpg",
        },
        standard: {
          bgTitle: "/en/assets/images/pages/rooms-suites/bg-title/bg_standard.jpg",
          bgTitleSp: "/en/assets/images/pages/rooms-suites/bg-title/bg_standard_sp.jpg",
          listImage: "/en/assets/images/pages/rooms-suites/img_list_standard.jpg",
          image01: "/en/assets/images/pages/rooms-suites/img_standard_01.jpg",
          image02: "/en/assets/images/pages/rooms-suites/img_standard_02.jpg",
          image03: "/en/assets/images/pages/rooms-suites/img_standard_03.jpg",
          floorMap01:
            "/en/assets/images/pages/rooms-suites/floor-map/standardFloorStandardRoomsStandardDouble.jpg",
          floorMap02:
            "/en/assets/images/pages/rooms-suites/floor-map/standardFloorStandardRoomsStandardSingle.jpg",
          floorMap03:
            "/en/assets/images/pages/rooms-suites/floor-map/standardFloorStandardRoomsStandardTwin.jpg",
        },
        standardDeluxe: {
          bgTitle:
            "/en/assets/images/pages/rooms-suites/bg-title/bg_standard-deluxe.jpg",
          bgTitleSp:
            "/en/assets/images/pages/rooms-suites/bg-title/bg_standard-deluxe_sp.jpg",
          listImage:
            "/en/assets/images/pages/rooms-suites/img_list_standard-deluxe.jpg",
          image01:
            "/en/assets/images/pages/rooms-suites/img_standard-deluxe_01.jpg",
          image02:
            "/en/assets/images/pages/rooms-suites/img_standard-deluxe_02.jpg",
          image03:
            "/en/assets/images/pages/rooms-suites/img_standard-deluxe_03.jpg",
          image04:
            "/en/assets/images/pages/rooms-suites/img_standard-deluxe_04.jpg",
          floorMap01:
            "/en/assets/images/pages/rooms-suites/floor-map/standardFloorDeluxeRoomsStandardDeluxeDouble.jpg",
          floorMap02:
            "/en/assets/images/pages/rooms-suites/floor-map/standardFloorDeluxeRoomsStandardDeluxeTwin.jpg",
        },
        towerSuite: {
          bgTitle:
            "/en/assets/images/pages/rooms-suites/bg-title/bg_tower-suite.jpg",
          bgTitleSp:
            "/en/assets/images/pages/rooms-suites/bg-title/bg_tower-suite_sp.jpg",
          listImage:
            "/en/assets/images/pages/rooms-suites/img_list_tower-suite.jpg",
          image01:
            "/en/assets/images/pages/rooms-suites/img_tower-suite_01.jpg",
          image02:
            "/en/assets/images/pages/rooms-suites/img_tower-suite_02.jpg",
          image03:
            "/en/assets/images/pages/rooms-suites/img_tower-suite_03.jpg",
          image04:
            "/en/assets/images/pages/rooms-suites/img_tower-suite_04.jpg",
          floorMap01:
            "/en/assets/images/pages/rooms-suites/floor-map/towerSuite.jpg",
        },
        exclusiveBenefits: {
          image01:
            "/en/assets/images/pages/rooms-suites/tmb_exclusive-benefits_01.jpg",
          image02:
            "/en/assets/images/pages/rooms-suites/tmb_exclusive-benefits_02.jpg",
          image03:
            "/en/assets/images/pages/rooms-suites/tmb_exclusive-benefits_03.jpg",
          image04:
            "/en/assets/images/pages/rooms-suites/tmb_exclusive-benefits_04.jpg",
          image05:
            "/en/assets/images/pages/rooms-suites/tmb_exclusive-benefits_05.jpg",
          image06:
            "/en/assets/images/pages/rooms-suites/tmb_exclusive-benefits_06.jpg",
        },
      },
      dining: {
        top: {
          bgTitle: "/en/assets/images/pages/dining/bg-title/bg_dining.jpg",
          bgTitleSp: "/en/assets/images/pages/dining/bg-title/bg_dining_sp.jpg",
          symphony: "/en/assets/images/pages/dining/img_top_symphony.jpg",
          genjikoh: "/en/assets/images/pages/dining/img_top_genjikoh.jpg",
          sumida: "/en/assets/images/pages/dining/img_top_sumida.jpg",
          iki: "/en/assets/images/pages/dining/img_top_iki.jpg",
          keiKaEn: "/en/assets/images/pages/dining/img_top_kei-ka-en.jpg",
          royalScots: "/en/assets/images/pages/dining/img_top_royal-scots.jpg",
          yanoneSushi: "/en/assets/images/pages/dining/img_top_yanone-sushi.jpg",
          fontaine: "/en/assets/images/pages/dining/img_top_fontaine.jpg",
        },
        teppanyakiSumida: {
          bgTitle: "/en/assets/images/pages/dining/bg-title/bg_sumida.jpg",
          bgTitleSp: "/en/assets/images/pages/dining/bg-title/bg_sumida_sp.jpg",
          listImage: "/en/assets/images/pages/dining/img_list_sumida.jpg",
          image01: "/en/assets/images/pages/dining/img_sumida_01.jpg",
          image02: "/en/assets/images/pages/dining/img_sumida_02.jpg",
          image03: "/en/assets/images/pages/dining/img_sumida_03.jpg",
          image04: "/en/assets/images/pages/dining/img_sumida_04.jpg",
          image05: "/en/assets/images/pages/dining/img_sumida_05.jpg",
          image06: "/en/assets/images/pages/dining/img_sumida_06.jpg",
          image07: "/en/assets/images/pages/dining/img_sumida_07.jpg",
        },
        japaneseRestaurantGenjikoh: {
          bgTitle: "/en/assets/images/pages/dining/bg-title/bg_genjikoh.jpg",
          bgTitleSp: "/en/assets/images/pages/dining/bg-title/bg_genjikoh_sp.jpg",
          listImage: "/en/assets/images/pages/dining/img_list_genjikoh.jpg",
          image01: "/en/assets/images/pages/dining/img_genjikoh_01.jpg",
          image02: "/en/assets/images/pages/dining/img_genjikoh_02.jpg",
          image03: "/en/assets/images/pages/dining/img_genjikoh_03.jpg",
          image04: "/en/assets/images/pages/dining/img_genjikoh_04.jpg",
          image05: "/en/assets/images/pages/dining/img_genjikoh_05.jpg",
          image06: "/en/assets/images/pages/dining/img_genjikoh_06.jpg",
          image07: "/en/assets/images/pages/dining/img_genjikoh_07.jpg",
          image08: "/en/assets/images/pages/dining/img_genjikoh_08.jpg",
          image09: "/en/assets/images/pages/dining/img_genjikoh_09.jpg",
          image10: "/en/assets/images/pages/dining/img_genjikoh_10.jpg",
          image11: "/en/assets/images/pages/dining/img_genjikoh_11.jpg",
          image12: "/en/assets/images/pages/dining/img_genjikoh_12.jpg",
          image13: "/en/assets/images/pages/dining/img_genjikoh_13.jpg",
        },
        chineseRestaurantKeiKaEn: {
          bgTitle: "/en/assets/images/pages/dining/bg-title/bg_kei-ka-en.jpg",
          bgTitleSp: "/en/assets/images/pages/dining/bg-title/bg_kei-ka-en_sp.jpg",
          listImage: "/en/assets/images/pages/dining/img_list_kei-ka-en.jpg",
          image01: "/en/assets/images/pages/dining/img_kei-ka-en_01.jpg",
          image02: "/en/assets/images/pages/dining/img_kei-ka-en_02.jpg",
          image03: "/en/assets/images/pages/dining/img_kei-ka-en_03.jpg",
          image04: "/en/assets/images/pages/dining/img_kei-ka-en_04.jpg",
          image05: "/en/assets/images/pages/dining/img_kei-ka-en_05.jpg",
          image06: "/en/assets/images/pages/dining/img_kei-ka-en_06.jpg",
          image07: "/en/assets/images/pages/dining/img_kei-ka-en_07.jpg",
          image08: "/en/assets/images/pages/dining/img_kei-ka-en_08.jpg",
        },
        sushiRestaurantYanoneSushi: {
          bgTitle: "/en/assets/images/pages/dining/bg-title/bg_yanone.jpg",
          bgTitleSp: "/en/assets/images/pages/dining/bg-title/bg_yanone_sp.jpg",
          listImage: "/en/assets/images/pages/dining/img_list_yanone.jpg",
          image01: "/en/assets/images/pages/dining/img_yanone_01.jpg",
          image02: "/en/assets/images/pages/dining/img_yanone_02.jpg",
          image03: "/en/assets/images/pages/dining/img_yanone_03.jpg",
          image04: "/en/assets/images/pages/dining/img_yanone_04.jpg",
          image05: "/en/assets/images/pages/dining/img_yanone_05.jpg",
          image06: "/en/assets/images/pages/dining/img_yanone_06.jpg",
          image07: "/en/assets/images/pages/dining/img_yanone_07.jpg",
          image08: "/en/assets/images/pages/dining/img_yanone_08.jpg",
          image09: "/en/assets/images/pages/dining/img_yanone_09.jpg",
          image10: "/en/assets/images/pages/dining/img_yanone_10.jpg",
        },
        chefsDiningSymphony: {
          bgTitle: "/en/assets/images/pages/dining/bg-title/bg_symphony.jpg",
          bgTitleSp: "/en/assets/images/pages/dining/bg-title/bg_symphony_sp.jpg",
          listImage: "/en/assets/images/pages/dining/img_list_symphony.jpg",
          image01: "/en/assets/images/pages/dining/img_symphony_01.jpg",
          image02: "/en/assets/images/pages/dining/img_symphony_02.jpg",
          image03: "/en/assets/images/pages/dining/img_symphony_03.jpg",
          image04: "/en/assets/images/pages/dining/img_symphony_04.jpg",
          image05: "/en/assets/images/pages/dining/img_symphony_05.jpg",
          image06: "/en/assets/images/pages/dining/img_symphony_06.jpg",
        },
        lobbyLoungeFontaine: {
          bgTitle: "/en/assets/images/pages/dining/bg-title/bg_fontaine.jpg",
          bgTitleSp: "/en/assets/images/pages/dining/bg-title/bg_fontaine_sp.jpg",
          listImage: "/en/assets/images/pages/dining/img_list_fontaine.jpg",
          image01: "/en/assets/images/pages/dining/img_fontaine_01.jpg",
          image02: "/en/assets/images/pages/dining/img_fontaine_02.jpg",
          image03: "/en/assets/images/pages/dining/img_fontaine_03.jpg",
          image04: "/en/assets/images/pages/dining/img_fontaine_04.jpg",
          image05: "/en/assets/images/pages/dining/img_fontaine_05.jpg",
          image06: "/en/assets/images/pages/dining/img_fontaine_06.jpg",
          image07: "/en/assets/images/pages/dining/img_fontaine_07.jpg",
          image08: "/en/assets/images/pages/dining/img_fontaine_08.jpg",
        },
        mainBarRoyalScots: {
          bgTitle: "/en/assets/images/pages/dining/bg-title/bg_royal-scots.jpg",
          bgTitleSp: "/en/assets/images/pages/dining/bg-title/bg_royal-scots_sp.jpg",
          listImage: "/en/assets/images/pages/dining/img_list_royal-scots.jpg",
          image01: "/en/assets/images/pages/dining/img_royal-scots_01.jpg",
          image02: "/en/assets/images/pages/dining/img_royal-scots_02.jpg",
          image03: "/en/assets/images/pages/dining/img_royal-scots_03.jpg",
          image04: "/en/assets/images/pages/dining/img_royal-scots_04.jpg",
          image05: "/en/assets/images/pages/dining/img_royal-scots_05.jpg",
          image06: "/en/assets/images/pages/dining/img_royal-scots_06.jpg",
          image07: "/en/assets/images/pages/dining/img_royal-scots_07.jpg",
        },
        sweetsBakeryIki: {
          bgTitle: "/en/assets/images/pages/dining/bg-title/bg_iki.jpg",
          bgTitleSp: "/en/assets/images/pages/dining/bg-title/bg_iki_sp.jpg",
          listImage: "/en/assets/images/pages/dining/img_list_iki.jpg",
          image01: "/en/assets/images/pages/dining/img_iki_01.jpg",
          image02: "/en/assets/images/pages/dining/img_iki_02.jpg",
          image03: "/en/assets/images/pages/dining/img_iki_03.jpg",
          image04: "/en/assets/images/pages/dining/img_iki_04.jpg",
          image05: "/en/assets/images/pages/dining/img_iki_05.jpg",
          image06: "/en/assets/images/pages/dining/img_iki_06.jpg",
        },
        japaneseGardenTeahouse: {
          bgTitle:
            "/en/assets/images/pages/dining/bg-title/bg_japanese-garden-teahouse.jpg",
          bgTitleSp:
            "/en/assets/images/pages/dining/bg-title/bg_japanese-garden-teahouse_sp.jpg",
          image01:
            "/en/assets/images/pages/dining/img_japanese-garden-teahouse_01.jpg",
          image02:
            "/en/assets/images/pages/dining/img_japanese-garden-teahouse_02.jpg",
          image03:
            "/en/assets/images/pages/dining/img_japanese-garden-teahouse_03.jpg",
          image04:
            "/en/assets/images/pages/dining/img_japanese-garden-teahouse_04.jpg",
        },
      },
      meetingsEvents: {
        top: {
          bgTitle:
            "/en/assets/images/pages/meetings-events/bg-title/bg_meetings-events.jpg",
          bgTitleSp:
            "/en/assets/images/pages/meetings-events/bg-title/bg_meetings-events_sp.jpg",
        },
        chooseOurMeetings: {
          bgTitle:
            "/en/assets/images/pages/meetings-events/bg-title/bg_meetings.jpg",
          bgTitleSp:
            "/en/assets/images/pages/meetings-events/bg-title/bg_meetings_sp.jpg",
          image01: "/en/assets/images/pages/meetings-events/img_meetings_01.jpg",
          image02: "/en/assets/images/pages/meetings-events/img_meetings_02.jpg",
          image03: "/en/assets/images/pages/meetings-events/img_meetings_03.jpg",
          // image04: "/en/assets/images/pages/meetings-events/img_meetings_04.jpg",
        },
        chooseOurEvents: {
          bgTitle: "/en/assets/images/pages/meetings-events/bg-title/bg_event.jpg",
          bgTitleSp: "/en/assets/images/pages/meetings-events/bg-title/bg_event_sp.jpg",
          image01: "/en/assets/images/pages/meetings-events/img_events_01.jpg",
          image02: "/en/assets/images/pages/meetings-events/img_events_02.jpg",
          image03: "/en/assets/images/pages/meetings-events/img_events_03.jpg",
        },
        chooseOurParties: {
          bgTitle: "/en/assets/images/pages/meetings-events/bg-title/bg_party.jpg",
          bgTitleSp: "/en/assets/images/pages/meetings-events/bg-title/bg_party_sp.jpg",
          image01: "/en/assets/images/pages/meetings-events/img_party_01.jpg",
          image02: "/en/assets/images/pages/meetings-events/img_party_02.jpg",
          image03: "/en/assets/images/pages/meetings-events/img_party_03.jpg",
          image04: "/en/assets/images/pages/meetings-events/img_party_04.jpg",
          image05: "/en/assets/images/pages/meetings-events/img_party_05.jpg",
        },
        grandRoyalHall: {
          bgTitle: "/en/assets/images/pages/meetings-events/bg-title/bg_royal-hall.jpg",
          bgTitleSp: "/en/assets/images/pages/meetings-events/bg-title/bg_royal-hall_sp.jpg",
          listImage: "/en/assets/images/pages/meetings-events/img_list_royal-hall.jpg",
          image01: "/en/assets/images/pages/meetings-events/img_royal-hall_01.jpg",
          image02: "/en/assets/images/pages/meetings-events/img_royal-hall_02.jpg",
          image03: "/en/assets/images/pages/meetings-events/img_royal-hall_03.jpg",
          image04: "/en/assets/images/pages/meetings-events/img_royal-hall_04.jpg",
          imageSm01: "/en/assets/images/pages/meetings-events/img_royal-hall_sm_01.jpg",
          imageSm02: "/en/assets/images/pages/meetings-events/img_royal-hall_sm_02.jpg",
          imageSm03: "/en/assets/images/pages/meetings-events/img_royal-hall_sm_03.jpg",
        },
        ariake: {
          bgTitle: "/en/assets/images/pages/meetings-events/bg-title/bg_ariake.jpg",
          bgTitleSp: "/en/assets/images/pages/meetings-events/bg-title/bg_ariake_sp.jpg",
          listImage: "/en/assets/images/pages/meetings-events/img_list_ariake.jpg",
          image01: "/en/assets/images/pages/meetings-events/img_ariake_01.jpg",
          image02: "/en/assets/images/pages/meetings-events/img_ariake_02.jpg",
          image03: "/en/assets/images/pages/meetings-events/img_ariake_03.jpg",
          imageSm01: "/en/assets/images/pages/meetings-events/img_ariake_sm_01.jpg",
          imageSm02: "/en/assets/images/pages/meetings-events/img_ariake_sm_02.jpg",
          imageSm03: "/en/assets/images/pages/meetings-events/img_ariake_sm_03.jpg",
        },
        shinonome: {
          bgTitle: "/en/assets/images/pages/meetings-events/bg-title/bg_shinonome.jpg",
          bgTitleSp: "/en/assets/images/pages/meetings-events/bg-title/bg_shinonome_sp.jpg",
          listImage: "/en/assets/images/pages/meetings-events/img_list_shinonome.jpg",
          image01: "/en/assets/images/pages/meetings-events/img_shinonome_01.jpg",
          image02: "/en/assets/images/pages/meetings-events/img_shinonome_02.jpg",
          image03: "/en/assets/images/pages/meetings-events/img_shinonome_03.jpg",
          imageSm01: "/en/assets/images/pages/meetings-events/img_shinonome_sm_01.jpg",
          imageSm02: "/en/assets/images/pages/meetings-events/img_shinonome_sm_02.jpg",
          imageSm03: "/en/assets/images/pages/meetings-events/img_shinonome_sm_03.jpg",
        },
        harumi: {
          bgTitle: "/en/assets/images/pages/meetings-events/bg-title/bg_harumi.jpg",
          bgTitleSp: "/en/assets/images/pages/meetings-events/bg-title/bg_harumi_sp.jpg",
          listImage: "/en/assets/images/pages/meetings-events/img_list_harumi.jpg",
          image01: "/en/assets/images/pages/meetings-events/img_harumi_01.jpg",
          image02: "/en/assets/images/pages/meetings-events/img_harumi_02.jpg",
          image03: "/en/assets/images/pages/meetings-events/img_harumi_03.jpg",
          imageSm01: "/en/assets/images/pages/meetings-events/img_harumi_sm_01.jpg",
          imageSm02: "/en/assets/images/pages/meetings-events/img_harumi_sm_02.jpg",
          imageSm03: "/en/assets/images/pages/meetings-events/img_harumi_sm_03.jpg",
        },
        ruri: {
          bgTitle: "/en/assets/images/pages/meetings-events/bg-title/bg_ruri.jpg",
          bgTitleSp: "/en/assets/images/pages/meetings-events/bg-title/bg_ruri_sp.jpg",
          listImage: "/en/assets/images/pages/meetings-events/img_list_ruri.jpg",
          image01: "/en/assets/images/pages/meetings-events/img_ruri_01.jpg",
          image02: "/en/assets/images/pages/meetings-events/img_ruri_02.jpg",
          image03: "/en/assets/images/pages/meetings-events/img_ruri_03.jpg",
          imageSm01: "/en/assets/images/pages/meetings-events/img_ruri_sm_01.jpg",
          imageSm02: "/en/assets/images/pages/meetings-events/img_ruri_sm_02.jpg",
          imageSm03: "/en/assets/images/pages/meetings-events/img_ruri_sm_03.jpg",
        },
        crown: {
          bgTitle: "/en/assets/images/pages/meetings-events/bg-title/bg_crown.jpg",
          bgTitleSp: "/en/assets/images/pages/meetings-events/bg-title/bg_crown_sp.jpg",
          listImage: "/en/assets/images/pages/meetings-events/img_list_crown.jpg",
          image01: "/en/assets/images/pages/meetings-events/img_crown_01.jpg",
          image02: "/en/assets/images/pages/meetings-events/img_crown_02.jpg",
          image03: "/en/assets/images/pages/meetings-events/img_crown_03.jpg",
          image04: "/en/assets/images/pages/meetings-events/img_crown_04.jpg",
          image05: "/en/assets/images/pages/meetings-events/img_crown_05.jpg",
          imageSm01: "/en/assets/images/pages/meetings-events/img_crown_sm_01.jpg",
          imageSm02: "/en/assets/images/pages/meetings-events/img_crown_sm_02.jpg",
          imageSm03: "/en/assets/images/pages/meetings-events/img_crown_sm_03.jpg",
        },
        palazzo: {
          bgTitle: "/en/assets/images/pages/meetings-events/bg-title/bg_palazzo.jpg",
          bgTitleSp: "/en/assets/images/pages/meetings-events/bg-title/bg_palazzo_sp.jpg",
          listImage: "/en/assets/images/pages/meetings-events/img_list_palazzo.jpg",
          image01: "/en/assets/images/pages/meetings-events/img_palazzo_01.jpg",
          image02: "/en/assets/images/pages/meetings-events/img_palazzo_02.jpg",
          image03: "/en/assets/images/pages/meetings-events/img_palazzo_03.jpg",
          image04: "/en/assets/images/pages/meetings-events/img_palazzo_04.jpg",
          imageSm01: "/en/assets/images/pages/meetings-events/img_palazzo_sm_01.jpg",
          imageSm02: "/en/assets/images/pages/meetings-events/img_palazzo_sm_02.jpg",
          imageSm03: "/en/assets/images/pages/meetings-events/img_palazzo_sm_03.jpg",
        },
        kohaku: {
          bgTitle: "/en/assets/images/pages/meetings-events/bg-title/bg_kohaku.jpg",
          bgTitleSp: "/en/assets/images/pages/meetings-events/bg-title/bg_kohaku_sp.jpg",
          listImage: "/en/assets/images/pages/meetings-events/img_list_kohaku.jpg",
          image01: "/en/assets/images/pages/meetings-events/img_kohaku_01.jpg",
          imageSm01: "/en/assets/images/pages/meetings-events/img_kohaku_sm_01.jpg",
          imageSm02: "/en/assets/images/pages/meetings-events/img_kohaku_sm_02.jpg",
          imageSm03: "/en/assets/images/pages/meetings-events/img_kohaku_sm_03.jpg",
        },
        kasumiAyaUtage: {
          bgTitle: "/en/assets/images/pages/meetings-events/bg-title/bg_kasumi-ata-utage.jpg",
          bgTitleSp: "/en/assets/images/pages/meetings-events/bg-title/bg_kasumi-ata-utage_sp.jpg",
          listImage: "/en/assets/images/pages/meetings-events/img_list_kasumi-ata-utage.jpg",
          image01: "/en/assets/images/pages/meetings-events/img_kasumi-ata-utage_01.jpg",
          imageSm01: "/en/assets/images/pages/meetings-events/img_kasumi-ata-utage_sm_01.jpg",
          imageSm02: "/en/assets/images/pages/meetings-events/img_kasumi-ata-utage_sm_02.jpg",
          imageSm03: "/en/assets/images/pages/meetings-events/img_kasumi-ata-utage_sm_03.jpg",
        },
        bridesRoom: {
          bgTitle: "/en/assets/images/pages/meetings-events/bg-title/bg_brides.jpg",
          bgTitleSp: "/en/assets/images/pages/meetings-events/bg-title/bg_brides_sp.jpg",
          listImage: "/en/assets/images/pages/meetings-events/img_list_brides.jpg",
          image01: "/en/assets/images/pages/meetings-events/img_brides_01.jpg",
        },
        roseRoom: {
          bgTitle: "/en/assets/images/pages/meetings-events/bg-title/bg_rose.jpg",
          bgTitleSp: "/en/assets/images/pages/meetings-events/bg-title/bg_rose_sp.jpg",
          listImage: "/en/assets/images/pages/meetings-events/img_list_rose.jpg",
          image01: "/en/assets/images/pages/meetings-events/img_rose_01.jpg",
          image02: "/en/assets/images/pages/meetings-events/img_rose_02.jpg",
          image04: "/en/assets/images/pages/meetings-events/img_rose_04.jpg",
          // image03: "/en/assets/images/pages/meetings-events/img_rose_03.jpg",
        },
        meetingRoom: {
          bgTitle: "/en/assets/images/pages/meetings-events/bg-title/bg_meeting-room.jpg",
          bgTitleSp: "/en/assets/images/pages/meetings-events/bg-title/bg_meeting-room_sp.jpg",
          listImage: "/en/assets/images/pages/meetings-events/img_list_meeting-room.jpg",
          image01: "/en/assets/images/pages/meetings-events/img_meeting-room_01.jpg",
          image02: "/en/assets/images/pages/meetings-events/img_meeting-room_02.jpg",
          image03: "/en/assets/images/pages/meetings-events/img_meeting-room_03.jpg",
        },
        useCases: {
          image01: "/en/assets/images/pages/meetings-events/tmb_usecases_01.jpg",
          image02: "/en/assets/images/pages/meetings-events/tmb_usecases_02.jpg",
          image03: "/en/assets/images/pages/meetings-events/tmb_usecases_03.jpg",
        },
      },
      destinationsActivities: {
        top: {
          bgTitle:
            "/en/assets/images/pages/destinations-activities/bg-title/bg_top.jpg",
          bgTitleSp:
            "/en/assets/images/pages/destinations-activities/bg-title/bg_top_sp.jpg",
          image01:
            "/en/assets/images/pages/destinations-activities/top/img_destination-activities_01.jpg",
          image02:
            "/en/assets/images/pages/destinations-activities/top/img_destination-activities_02.jpg",
          image03:
            "/en/assets/images/pages/destinations-activities/top/img_destination-activities_03.jpg",
          image04:
            "/en/assets/images/pages/destinations-activities/top/img_destination-activities_04.jpg",
          image05:
            "/en/assets/images/pages/destinations-activities/top/img_destination-activities_05.jpg",
          image06:
            "/en/assets/images/pages/destinations-activities/top/img_destination-activities_06.jpg",
          image07:
            "/en/assets/images/pages/destinations-activities/top/img_destination-activities_07.jpg",
          image08:
            "/en/assets/images/pages/destinations-activities/top/img_destination-activities_08.jpg",
          image09:
            "/en/assets/images/pages/destinations-activities/top/img_destination-activities_09.jpg",
          seasonalExperience01:
            "/en/assets/images/pages/destinations-activities/top/img_seasonal_experience_01.jpg",
          seasonalExperience02:
            "/en/assets/images/pages/destinations-activities/top/img_seasonal_experience_02.jpg",
          seasonalExperience03:
            "/en/assets/images/pages/destinations-activities/top/img_seasonal_experience_03.jpg",
          seasonalExperience04:
            "/en/assets/images/pages/destinations-activities/top/img_seasonal_experience_04.jpg",
          neighborhood01:
            "/en/assets/images/pages/destinations-activities/top/img_neighborhood_01.jpg",
          neighborhood02:
            "/en/assets/images/pages/destinations-activities/top/img_neighborhood_02.jpg",
          neighborhood03:
            "/en/assets/images/pages/destinations-activities/top/img_neighborhood_03.jpg",
          neighborhood04:
            "/en/assets/images/pages/destinations-activities/top/img_neighborhood_04.jpg",
          neighborhood05:
            "/en/assets/images/pages/destinations-activities/top/img_neighborhood_05.jpg",
          neighborhood06:
            "/en/assets/images/pages/destinations-activities/top/img_neighborhood_06.jpg",
          neighborhood07:
            "/en/assets/images/pages/destinations-activities/top/img_neighborhood_07.jpg",
          neighborhood08:
            "/en/assets/images/pages/destinations-activities/top/img_neighborhood_08.jpg",
          neighborhood09:
            "/en/assets/images/pages/destinations-activities/top/img_neighborhood_09.jpg",
          neighborhood10:
            "/en/assets/images/pages/destinations-activities/top/img_neighborhood_10.jpg",
          neighborhood11:
            "/en/assets/images/pages/destinations-activities/top/img_neighborhood_11.jpg",
          neighborhood12:
            "/en/assets/images/pages/destinations-activities/top/img_neighborhood_12.jpg",
          neighborhood13:
            "/en/assets/images/pages/destinations-activities/top/img_neighborhood_13.jpg",
          neighborhood14:
            "/en/assets/images/pages/destinations-activities/top/img_neighborhood_14.jpg",
        },
        location: {
          bgTitle:
            "/en/assets/images/pages/destinations-activities/bg-title/bg_location.jpg",
          bgTitleSp:
            "/en/assets/images/pages/destinations-activities/bg-title/bg_location_sp.jpg",
          image01:
            "/en/assets/images/pages/destinations-activities/location/img_map_01.jpg",
          image02:
            "/en/assets/images/pages/destinations-activities/location/img_map_02.jpg",
          icons: {
            tCat: "/en/assets/images/pages/destinations-activities/location/ico_t-cat.png",
            s05: "/en/assets/images/pages/destinations-activities/location/ico_s05.svg",
            z08: "/en/assets/images/pages/destinations-activities/location/ico_z08.svg",
            z10: "/en/assets/images/pages/destinations-activities/location/ico_z10.svg",
            a14: "/en/assets/images/pages/destinations-activities/location/ico_a14.svg",
            a20: "/en/assets/images/pages/destinations-activities/location/ico_a20.svg",
            h14: "/en/assets/images/pages/destinations-activities/location/ico_h14.svg",
            m18: "/en/assets/images/pages/destinations-activities/location/ico_m18.svg",
            jc01: "/en/assets/images/pages/destinations-activities/location/ico_jc01.svg",
            airplane: "/en/assets/images/pages/destinations-activities/location/ico_airplane.svg",
            bus: "/en/assets/images/pages/destinations-activities/location/ico_bus.svg",
            train: "/en/assets/images/pages/destinations-activities/location/ico_train.svg",
            onFoot: "/en/assets/images/pages/destinations-activities/location/ico_onfoot.svg",
          },
        },
        perfectSightseeingServices: {
          bgTitle:
            "/en/assets/images/pages/destinations-activities/bg-title/bg_perfect-sightseeing-services.jpg",
          bgTitleSp:
            "/en/assets/images/pages/destinations-activities/bg-title/bg_perfect-sightseeing-services_sp.jpg",
          image01:
            "/en/assets/images/pages/destinations-activities/img_perfect-sightseeing-services_01.jpg",
          image02:
            "/en/assets/images/pages/destinations-activities/img_perfect-sightseeing-services_02.jpg",
          image03:
            "/en/assets/images/pages/destinations-activities/img_perfect-sightseeing-services_03.jpg",
          image04:
            "/en/assets/images/pages/destinations-activities/img_perfect-sightseeing-services_04.jpg",
          image05:
            "/en/assets/images/pages/destinations-activities/img_perfect-sightseeing-services_05.jpg",
        },
        roomKeyOffers: {
          bgTitle:
            "/en/assets/images/pages/destinations-activities/bg-title/bg_roomkey.jpg",
          bgTitleSp:
            "/en/assets/images/pages/destinations-activities/bg-title/bg_roomkey_sp.jpg",
          imgStep1:
            "/en/assets/images/pages/destinations-activities/room-key-offers/img_step1.png",
          imgStep2:
            "/en/assets/images/pages/destinations-activities/room-key-offers/img_step2.png",
          imgStep3:
            "/en/assets/images/pages/destinations-activities/room-key-offers/img_step3.png",
        },
      },
      roomKeyOffers: {
        mapPin01Image: "/en/assets/images/pages/roomkey-offers/takeaway_01.jpg",
        mapPin02Image: "/en/assets/images/pages/roomkey-offers/takeaway_02.jpg",
        mapPin03Image: "/en/assets/images/pages/roomkey-offers/takeaway_03.jpg",
        mapPin04Image: "/en/assets/images/pages/roomkey-offers/takeaway_04.jpg",
        mapPin05Image: "/en/assets/images/pages/roomkey-offers/takeaway_05.jpg",
        mapPin06Image: "/en/assets/images/pages/roomkey-offers/takeaway_06.jpg",
        mapPin07Image: "/en/assets/images/pages/roomkey-offers/takeaway_07.jpg",
        mapPin08Image: "/en/assets/images/pages/roomkey-offers/takeaway_08.jpg",
        mapPin09Image: "/en/assets/images/pages/roomkey-offers/takeaway_09.jpg",
        mapPin10Image: "/en/assets/images/pages/roomkey-offers/takeaway_10.jpg",
        mapPin11Image: "/en/assets/images/pages/roomkey-offers/takeaway_11.jpg",
        mapPin12Image: "/en/assets/images/pages/roomkey-offers/takeaway_12.jpg",
        mapPin13Image: "/en/assets/images/pages/roomkey-offers/takeaway_13.jpg",
        mapPin14Image: "/en/assets/images/pages/roomkey-offers/takeaway_14.jpg",
        mapPin15Image: "/en/assets/images/pages/roomkey-offers/takeaway_15.jpg",
        mapPin16Image: "/en/assets/images/pages/roomkey-offers/takeaway_16.jpg",
        mapPin17Image: "/en/assets/images/pages/roomkey-offers/takeaway_17.jpg",
        mapPin18Image: "/en/assets/images/pages/roomkey-offers/takeaway_18.jpg",
        mapPin19Image: "/en/assets/images/pages/roomkey-offers/takeaway_19.jpg",
        mapPin20Image: "/en/assets/images/pages/roomkey-offers/culinary_01.jpg",
        mapPin21Image: "/en/assets/images/pages/roomkey-offers/culinary_02.jpg",
        mapPin22Image: "/en/assets/images/pages/roomkey-offers/culinary_03.jpg",
        mapPin23Image: "/en/assets/images/pages/roomkey-offers/culinary_04.jpg",
        mapPin24Image: "/en/assets/images/pages/roomkey-offers/culinary_05.jpg",
        mapPin25Image: "/en/assets/images/pages/roomkey-offers/culinary_06.jpg",
        mapPin26Image: "/en/assets/images/pages/roomkey-offers/sightseeing_01.jpg",
        mapPin27Image: "/en/assets/images/pages/roomkey-offers/sightseeing_02.jpg",
        mapPin28Image: "/en/assets/images/pages/roomkey-offers/sightseeing_03.jpg",
        mapPin29Image: "/en/assets/images/pages/roomkey-offers/sightseeing_04.jpg",
        mapPin30Image: "/en/assets/images/pages/roomkey-offers/sightseeing_05.jpg",
        mapPin31Image: "/en/assets/images/pages/roomkey-offers/sightseeing_06.jpg",
        mapPin32Image: "/en/assets/images/pages/roomkey-offers/sightseeing_07.jpg",
        mapPin33Image: "/en/assets/images/pages/roomkey-offers/sightseeing_08.jpg",
        mapPin34Image: "/en/assets/images/pages/roomkey-offers/sightseeing_09.jpg",
        mapPin35Image: "/en/assets/images/pages/roomkey-offers/sightseeing_10.jpg",
        mapPin36Image: "/en/assets/images/pages/roomkey-offers/sightseeing_11.jpg",
        mapPin37Image: "/en/assets/images/pages/roomkey-offers/dining-shopping_01.jpg",
        mapPin38Image: "/en/assets/images/pages/roomkey-offers/dining-shopping_02.jpg",
        mapPin39Image: "/en/assets/images/pages/roomkey-offers/dining-shopping_03.jpg",
        mapPin40Image: "/en/assets/images/pages/roomkey-offers/dining-shopping_04.jpg",
        mapPin41Image: "/en/assets/images/pages/roomkey-offers/dining-shopping_05.jpg",
        mapPin42Image: "/en/assets/images/pages/roomkey-offers/dining-shopping_06.jpg",
      },
      gallery: {
        bgTitle: "/en/assets/images/pages/gallery/bg_gallery.jpg",
        bgTitleSp: "/en/assets/images/pages/gallery/bg_gallery_sp.jpg",
        roomsSuites: {
          image01: "/en/assets/images/pages/gallery/rooms-suites/image01.jpg",
          image02: "/en/assets/images/pages/gallery/rooms-suites/image02.jpg",
          image03: "/en/assets/images/pages/gallery/rooms-suites/image03.jpg",
          image04: "/en/assets/images/pages/gallery/rooms-suites/image04.jpg",
          image05: "/en/assets/images/pages/gallery/rooms-suites/image05.jpg",
          image06: "/en/assets/images/pages/gallery/rooms-suites/image06.jpg",
          image07: "/en/assets/images/pages/gallery/rooms-suites/image07.jpg",
          image08: "/en/assets/images/pages/gallery/rooms-suites/image08.jpg",
          image09: "/en/assets/images/pages/gallery/rooms-suites/image09.jpg",
          image10: "/en/assets/images/pages/gallery/rooms-suites/image10.jpg",
          image11: "/en/assets/images/pages/gallery/rooms-suites/image11.jpg",
          image12: "/en/assets/images/pages/gallery/rooms-suites/image12.jpg",
          image13: "/en/assets/images/pages/gallery/rooms-suites/image13.jpg",
          image14: "/en/assets/images/pages/gallery/rooms-suites/image14.jpg",
          image15: "/en/assets/images/pages/gallery/rooms-suites/image15.jpg",
          image16: "/en/assets/images/pages/gallery/rooms-suites/image16.jpg",
          image17: "/en/assets/images/pages/gallery/rooms-suites/image17.jpg",
          image18: "/en/assets/images/pages/gallery/rooms-suites/image18.jpg",
          image19: "/en/assets/images/pages/gallery/rooms-suites/image19.jpg",
          image20: "/en/assets/images/pages/gallery/rooms-suites/image20.jpg",
          image21: "/en/assets/images/pages/gallery/rooms-suites/image21.jpg",
        },
        dining: {
          image01: "/en/assets/images/pages/gallery/dining/image01.jpg",
          image02: "/en/assets/images/pages/gallery/dining/image02.jpg",
          image03: "/en/assets/images/pages/gallery/dining/image03.jpg",
          image04: "/en/assets/images/pages/gallery/dining/image04.jpg",
          image05: "/en/assets/images/pages/gallery/dining/image05.jpg",
          image06: "/en/assets/images/pages/gallery/dining/image06.jpg",
          image07: "/en/assets/images/pages/gallery/dining/image07.jpg",
          image08: "/en/assets/images/pages/gallery/dining/image08.jpg",
          image09: "/en/assets/images/pages/gallery/dining/image09.jpg",
          image10: "/en/assets/images/pages/gallery/dining/image10.jpg",
          image11: "/en/assets/images/pages/gallery/dining/image11.jpg",
          image12: "/en/assets/images/pages/gallery/dining/image12.jpg",
          image13: "/en/assets/images/pages/gallery/dining/image13.jpg",
          image14: "/en/assets/images/pages/gallery/dining/image14.jpg",
          image15: "/en/assets/images/pages/gallery/dining/image15.jpg",
          image16: "/en/assets/images/pages/gallery/dining/image16.jpg",
          image17: "/en/assets/images/pages/gallery/dining/image17.jpg",
          image18: "/en/assets/images/pages/gallery/dining/image18.jpg",
          image19: "/en/assets/images/pages/gallery/dining/image19.jpg",
          image20: "/en/assets/images/pages/gallery/dining/image20.jpg",
          image21: "/en/assets/images/pages/gallery/dining/image21.jpg",
          image22: "/en/assets/images/pages/gallery/dining/image22.jpg",
          image23: "/en/assets/images/pages/gallery/dining/image23.jpg",
        },
        meetingEvents: {
          image01: "/en/assets/images/pages/gallery/meeting-events/image01.jpg",
          image02: "/en/assets/images/pages/gallery/meeting-events/image02.jpg",
          image03: "/en/assets/images/pages/gallery/meeting-events/image03.jpg",
          image04: "/en/assets/images/pages/gallery/meeting-events/image04.jpg",
          image05: "/en/assets/images/pages/gallery/meeting-events/image05.jpg",
          image06: "/en/assets/images/pages/gallery/meeting-events/image06.jpg",
          image07: "/en/assets/images/pages/gallery/meeting-events/image07.jpg",
          image08: "/en/assets/images/pages/gallery/meeting-events/image08.jpg",
          image09: "/en/assets/images/pages/gallery/meeting-events/image09.jpg",
        },
        facilities: {
          image01: "/en/assets/images/pages/gallery/facilities/image01.jpg",
          image02: "/en/assets/images/pages/gallery/facilities/image02.jpg",
          image03: "/en/assets/images/pages/gallery/facilities/image03.jpg",
          image04: "/en/assets/images/pages/gallery/facilities/image04.jpg",
          image05: "/en/assets/images/pages/gallery/facilities/image05.jpg",
          image06: "/en/assets/images/pages/gallery/facilities/image06.jpg",
          image07: "/en/assets/images/pages/gallery/facilities/image07.jpg",
          image08: "/en/assets/images/pages/gallery/facilities/image08.jpg",
          image09: "/en/assets/images/pages/gallery/facilities/image09.jpg",
          image10: "/en/assets/images/pages/gallery/facilities/image10.jpg",
          image11: "/en/assets/images/pages/gallery/facilities/image11.jpg",
          image12: "/en/assets/images/pages/gallery/facilities/image12.jpg",
          image13: "/en/assets/images/pages/gallery/facilities/image13.jpg",
          image14: "/en/assets/images/pages/gallery/facilities/image14.jpg",
          image15: "/en/assets/images/pages/gallery/facilities/image15.jpg",
          image16: "/en/assets/images/pages/gallery/facilities/image16.jpg",
        }
      },
      specialOffers: {
        image01: "/en/assets/images/pages/special-offers/tmb_bar.jpg",
        image02: "/en/assets/images/pages/special-offers/tmb_suites.jpg",
        image03: "/en/assets/images/pages/special-offers/tmb_more.jpg",
        image04: "/en/assets/images/pages/special-offers/tmb_breakfast.jpg",
        image05: "/en/assets/images/pages/special-offers/tmb_pes.jpg",
      },
    },
  },
  ko: {},
  "zh-cn": {},
  "zh-tw": {},
} as const;
